<template>
  <div class="items">
    <v-sheet class="py-3 py-md-6" color="primary">
      <TitleWidget dark>
        {{ title }}
      </TitleWidget>
    </v-sheet>

    <LoadingWidget v-if="loading" />

    <v-container v-else class="pb-10 pb-md-13 pb-lg-16">
      <div v-if="items.length" class="mt-6 mt-md-10 grid-list">
        <ServiceCard
          v-for="(item, keyItems) in items"
          :key="keyItems"
          v-bind="item"
        />
      </div>

      <v-alert v-else class="mt-5" type="info">
        Nenhum conteúdo adicionado até o momento.
      </v-alert>
    </v-container>
  </div>
</template>

<script>
import TitleWidget from "../components/widgets/TitleWidget.vue";
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import ServiceCard from "../components/cards/ServiceCard.vue";

const _config = {
  mod: "services",
};

const _data = {
  title: "Nossos Serviços",
  loading: true,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  created() {
    this.$rest(_config.mod)
      .get()
      .finally(() => (this.loading = false));
  },
  components: {
    TitleWidget,
    LoadingWidget,
    ServiceCard,
  },
};
</script>

<style lang="scss" scoped>
.items {
  .grid-list {
    display: grid;
    gap: 64px 30px;
    grid-template-columns: repeat(3, 1fr);

    @media screen and (max-width: 959.9px) {
      grid-template-columns: 1fr 1fr;
    }

    @media screen and (max-width: 599.9px) {
      grid-template-columns: 1fr;
    }
  }
}
</style>
